import { ContentBlock } from "api/dialog";
import Tilda from "components/Tilda";
import { Row, Typography } from "antd";
import React, { HTMLAttributes } from "react";
import { cssGrayscale } from "utils/utils";
import classNames from "classnames/bind";
import _styles from "./ContentBox.module.scss";
const styles = classNames.bind(_styles);

export interface ContentBoxProps {
  content: ContentBlock;
}

export const ContentBox = React.forwardRef<
  HTMLDivElement,
  ContentBoxProps & HTMLAttributes<HTMLDivElement>
>(({ content, ...rest }, ref) => {
  switch (content.type) {
    case "cards":
      const cards = content;
      return (
        <div {...rest} ref={ref}>
          {cards.items.map(({ title, description }) => (
            <div>
              <div
                style={{
                  color: `rgb(${content.textColor}, ${content.textColor}, ${content.textColor})`,
                }}
              >
                {title}
              </div>
              <Tilda />
              <div
                style={{
                  color: `rgb(${content.textColor}, ${content.textColor}, ${content.textColor})`,
                }}
              >
                {description}
              </div>
            </div>
          ))}
        </div>
      );
    case "description":
      const { icon, title, text } = content;
      return (
        <div {...rest} className={styles("block", rest.className)} ref={ref}>
          {icon && (
            <div className={styles("blockImg")}>
              <img src={icon} alt="Product icon" />
            </div>
          )}
          <Row>
            <Typography.Text
              className={styles("blockTitle")}
              style={{
                color: cssGrayscale(content.textColor),
              }}
            >
              {title}
            </Typography.Text>
          </Row>
          <Row style={{ minHeight: 0 }}>
            <Typography.Text
              className={styles("blockDesc")}
              style={{
                color: `rgb(${content.textColor}, ${content.textColor}, ${content.textColor})`,
              }}
            >
              {text}
            </Typography.Text>
          </Row>
        </div>
      );
  }
});
